import apiClient from '../../../lib/client';

export const mailerOrdersAPI = {
  preview: (payload) => apiClient.post('/mailer-orders/preview', payload).then((r) => r.data),
  create: (payload) => apiClient.post('/mailer-orders', payload).then((r) => r.data),
  getOrders: () => apiClient.get('/mailer-orders').then((r) => r.data),
  getOrder: (id) => apiClient.get(`/mailer-orders/${id}`).then((r) => r.data),
};
